import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {VerifyService} from "./services/verify.service";

@Component({
    selector: 'app-verify',
    templateUrl: './verify.component.html',
    encapsulation: ViewEncapsulation.None
})
export class VerifyComponent implements OnInit {

    message = 'Verifying... please wait a moment, we are verifying your registration code';
    success = false;
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private svc: VerifyService
    ) {
    }

    async ngOnInit(): Promise<void> {
        let code = this.activatedRoute.snapshot.params.code;
        let res = await this.svc.verify(code);
        if(res.value == 'success') {
            this.message = 'Your email address is verified, redirecting you to login page';
            this.success = true;
            setTimeout(() => {
                this.router.navigate(['/login']).then();
            }, 3000);

        } else {
            this.message = 'invalid verification code'
        }
    }

}